import React from 'react'
import './meta-data.scss'
import Report from '../../../utility/report-service'

const MetaData = () => {
  return (
    <div className="meta-data">
      <div className="container">
        <div className="title">
          <h1>SEO Website Audit</h1>
        </div>
        <div className="meta">
          <span>{Report.metaData.crawlDate}</span>
          <br />
          <span>{Report.metaData.websiteName}</span>
        </div>
      </div>
    </div>
  )
}

export default MetaData
